// src/com/trans_plan_launch/TransPlanLaunch.js
import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { styled  } from '@mui/material/styles';
import { TopContainer, TopHeader, TopContent, ControlLine, NoDataBox } from '../../common/TopStyle';
// import { Box } from '@mui/system';
import { IconButton, CircularProgress, Button, AppBar, Tabs, Tab, Collapse } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { ApiMsg, AppObject, AppStyle, AppWord, CodeGroup } from '../../value/AppConst';
import {
    arriveInfoListToSelectStoreRepo, codeTreeRepo,comInfoListRepo,transPlanLaunchListParamRepo, transPlanLaunchListRepo, transPlanTsrItemRepo, userInfoRepo,
    vehInfoListOfDcRepo,
    vehTypeGroupOrderListByDcRepo,
    waveListRepo
} from '../../value/AppModel';
import { useAlertSetter } from '../../api/app-hook';
import { GET_TRANS_PLAN_TSR, LIST_TRANS_PLAN_TSR } from '../tsr/TransPlanTsrGql';
import { LIST_ARRIVE_INFO } from '../arrive_info/ArriveInfoGql';
import { LIST_VEH_TYPE_GROUP_ORDER_BY_DC } from '../veh_type_group_order/VehTypeGroupOrderGql';
import { LIST_COM_INFO } from '../com_info/ComInfoGql';
import { devideVehiclesByCompany, LIST_VEH_INFO_OF_DC } from '../veh_info/VehInfoGql';
import { ADD_TRANS_PLAN, EDIT_TRANS_PLAN, OFF_TRANS_PLAN_TRUCK, REMOVE_TRANS_PLAN, SET_TRANS_PLAN_TRUCK } from '../trans_plan/TransPlanGql';
import ValueMisc from '../../value/ValueMisc';
import VzmDateField from '../../common/VzmDateField';
import IsValid from '../../value/IsValid';
import AutoTextField from '../../common/AutoTextField';
import TransPlanLaunchItem from './TransPlanLaunchItem';
import TransPlanTsrGroup from '../tsr/TransPlanTsrGroup';
import { TransitionGroup } from 'react-transition-group';


export const vehSorter = (a, b) => {
    const aNew = a.vehPlates.indexOf('신규') > -1;
    const bNew = b.vehPlates.indexOf('신규') > -1;
    if(aNew && !bNew) return 1;
    if(!aNew && bNew) return -1;
    return a.vehPlates.localeCompare(b.vehPlates);
};

/**
 * 운송요청 조회
 * 수동 배차등록 목록 (날짜, 도착지에 대하여 hocha들 나열(목록))
 * 1. 목록 조회해서 hocha순으로 Tab 표시. 선택된 Tab에 대응하는 hocha에 대한 운송요청 표시
 * 2. 각 호차별로 기본 정보 전달(baseData)
 * 3. 데이터 없는 경우도 있음(빈 상자) null item
 * 4. 배차 삭제 - 과거 PR_TRANS_PLAN_DEL
 * @param {*} param0 
 * @returns 
 */
export default function TransPlanLaunch() {
    const codeTree = useReactiveVar(codeTreeRepo);
    const sessionInfo = useReactiveVar(userInfoRepo);
    const storeList = useReactiveVar(arriveInfoListToSelectStoreRepo);
    const [listParam, setListParam] = useState({storeId: null, planDate: ValueMisc.getYMD()});
    const transPlanLaunchListParam = useReactiveVar(transPlanLaunchListParamRepo);
    //const transPlanLaunchListData = useReactiveVar(transPlanLaunchListRepo);
    const [launchBoxList, setLaunchBoxList] = useState([]); // [ {item, hocha} ]
    /* const [hochaNow, setHochaNow] = useState(0);
    const [tabNow, setTabNow] = useState(0);
    const [itemNow, setItemNow] = useState(null); */
    const [showControls, setShowControls] = useState(true);
    const [selected, setSelected] = useState({hocha:0, item:null});
    const [baseData, setBaseData] = useState({}); // {dcCd, arriveId, storeId, planDate}
    const [openTsrDetail, setOpenTsrDetail] = useState(false);
    const vehInfoListOfDcData = useReactiveVar(vehInfoListOfDcRepo);
    const vehTypeGroupOrderListByDc = useReactiveVar(vehTypeGroupOrderListByDcRepo);
    const vehTypeList = useMemo(()=>{
        if(vehTypeGroupOrderListByDc.records.length > 0) {
            const list = [...vehTypeGroupOrderListByDc.records];
            list.unshift({vehTypeId:AppWord.ChooseValue, vehTypeName:AppWord.ChooseKorean});
            return list;
        }
        return [{vehTypeId:AppWord.ChooseValue, vehTypeName:AppWord.ChooseKorean}];
    }, [vehTypeGroupOrderListByDc]);
    const comInfoListData = useReactiveVar(comInfoListRepo);
    const comInfoList = useMemo(()=>{
        if(comInfoListData.records.length > 0) {
            const dcCd = sessionInfo.user.getDcCd();
            const list = comInfoListData.records.filter(com=>com.dcCd===dcCd && com.useYn==='Y') //[...comInfoListData.records];
            list.unshift({comId:AppWord.ChooseValue, comName:AppWord.ChooseKorean});
            return list;
        }
        return [{comId:AppWord.ChooseValue, comName:AppWord.ChooseKorean}];
    }, [comInfoListData]);
    const [docknoMemo, setDocknoMemo] = useState(null);
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    // const slotCountWantedRef = useRef(DefaultBoxCount); // 원하는 호차 상자 수. 최소값=DafaultBoxCount
    // 빈 상자는 하나만 준비.
    const loadRef = useRef(false);
    const lastReloadRef = useRef(0);
    
    // ##### Call GraphQL to get List #####
    const [getTransPlanTsrList, responseList] = useLazyQuery(LIST_TRANS_PLAN_TSR, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
        onError: (error) => addAlert({title: "운송요청 조회 오류", message: [error.message]})
    });
    // Get store list from arrive_info table.
    const [getArriveInfoList, responseStoreList] = useLazyQuery(LIST_ARRIVE_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetStoreList(data, option)},
        onError: (error) => addAlert({title: '도착지 목록 조회 오류', message: [error.message]})
    });
    const [getVehTypeGroupOrderList, responseVehTypeList] = useLazyQuery(LIST_VEH_TYPE_GROUP_ORDER_BY_DC, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetVehTypeList(data, option)},
        onError: (error) => addAlert({title: "차종목록 조회 오류", message: [error.message]})
    });
    const [getComInfoList, responseComList] = useLazyQuery(LIST_COM_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetComList(data, option)},
        onError: (error) => addAlert({title: '운송사 목록 조회 오류', message: [error.message]})
    });
    const [getVehInfoListOfDc, responseVehInfoList] = useLazyQuery(LIST_VEH_INFO_OF_DC, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetVehInfoList(data, option)},
        onError: (error) => addAlert({title: "차량목록 조회 오류", message: [error.message]})
    });
    const [getTransPlanTsrItem, responsePlanItem] = useLazyQuery(GET_TRANS_PLAN_TSR, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetPlanItem(data, option)},
        onError: (error) => addAlert({title: "운송요청 정보 조회 오류", message: [error.message]})
    });

    // ##### GraphQL Mutation. 'onError' for prevent from printing error at cons-ole (Uncaught exception) ###
    const [addTransPlan, responseAdd] = useMutation( ADD_TRANS_PLAN, {
		onCompleted: (data, option) => onCompleteAdd(data, option), 
		onError: (error) => addAlert({title: '운송요청 등록 오류', message: [error.message]})
	} );
    const [editTransPlan, responseEdit] = useMutation( EDIT_TRANS_PLAN, {
		onCompleted: (data, option) => onCompleteEdit(data, option),
		onError: (error) => addAlert({title: '운송요청 수정 오류', message: [error.message]})
	} );
    const [removeTransPlan, responseRemove] = useMutation( REMOVE_TRANS_PLAN, {
		onCompleted: (data, option) => onCompleteRemove(data, option),
		onError: (error) => addAlert({title: '운송요청 삭제 오류', message: [error.message]})
	});
    const [setTransPlanTruck, responseSetTruck] = useMutation( SET_TRANS_PLAN_TRUCK, {
        onCompleted: (data, option) => onCompleteSetTruck(data, option),
        onError: (error) => addAlert({title: "차량배정 오류", message: [error.message]})
    });
    const [offTransPlanTruck, responseOffTruck] = useMutation( OFF_TRANS_PLAN_TRUCK, {
        onCompleted: (data, option) => onCompleteOffTruck(data, option),
        onError: (error) => addAlert({title: "차량배정 초기화 오류", message: [error.message]})
    });
    // 추가예정: 차량설정, 차량제거(초기화), 동적, 메시지, 운송요청 업로드

    const getTransPlanTsrListNow = (storeId, planDate) => {
        const dcCd = sessionInfo.user.getDcCd(); // sessionInfo.user.dscIdAs;
        if(!planDate) {
            planDate = ValueMisc.getYMD();
        }
        const param = {variables:{dcCd:dcCd, storeId:storeId, planDate:planDate}};
        getTransPlanTsrList(param);
        if(storeId !== transPlanLaunchListParam.storeId || planDate !== transPlanLaunchListParam.planDate) {
            transPlanLaunchListParamRepo(param);
        }
        lastReloadRef.current = new Date().getTime()/1000;
    };

    const getTransPlanTsrListUsingParam = () => {
        if(listParam.storeId && listParam.planDate) {
            getTransPlanTsrListNow(listParam.storeId, listParam.planDate);
        }
    };

    // 다른 화면에서 transPlanTsrListParam 설정하고 이 화면으로 들어오면 바로 조회 가능함.
    useEffect(() => {
        if(transPlanLaunchListParam.storeId && transPlanLaunchListParam.planDate
            && transPlanLaunchListParam.storeId !== listParam.storeId
            && transPlanLaunchListParam.planDate !== listParam.planDate
        ) {
            //getTransPlanTsrListNow(transPlanLaunchListParam.storeId, transPlanLaunchListParam.planDate);
            setListParam({storeId:transPlanLaunchListParam.storeId, planDate:transPlanLaunchListParam.planDate});
            getTransPlanTsrListNow(transPlanLaunchListParam.storeId, transPlanLaunchListParam.planDate);
        }
        else if(!transPlanLaunchListParam.planDate) {
            const newParam = {...transPlanLaunchListParam, planDate:ValueMisc.getYMD()};
            transPlanLaunchListParamRepo(newParam);
        }
    }, [transPlanLaunchListParam, listParam]);
    
    // 먼저 Store 목록을 가져온 후 transPlanTsrListParam의 내용에 따라서 최초 LIST_TRANS_PLAN_TSR 호출
    useEffect(() => {
        if(!loadRef.current) {
            const dcCd = sessionInfo.user.getDcCd(); // sessionInfo.user.dscIdAs;
            loadRef.current = true;
            let diff = new Date().getTime()/1000 - storeList.when;
            if(diff > 300) {
                getArriveInfoList({variables:{dcCd:dcCd}});
            }

            diff = new Date().getTime()/1000 - vehTypeGroupOrderListByDc.when;
            if(diff > 300) {
                getVehTypeGroupOrderList({variables:{dcCd:dcCd}});
            }

            diff = new Date().getTime()/1000 - comInfoListData.when;
            if(diff > 300) {
                getComInfoList();
            }

            diff = new Date().getTime()/1000 - vehInfoListOfDcData.when;
            if(diff > 300) {
                getVehInfoListOfDc({variables:{dcCd:dcCd}});
            }
            // const planGroup = ValueMisc.getCodes(codeTree, CodeGroup.AUTO_PLAN_ORDER_GROUP);
            const waveCodes = ValueMisc.getCodes(codeTree, CodeGroup.TRANS_TYPE_CD);
            const list = [{transTypeCd: AppWord.ChooseValue, label: AppWord.ChooseKorean}];
            waveCodes.forEach(item => {
                list.push({transTypeCd: item.codeId, label: item.codeName});
            });
            waveListRepo(list);
        }
    }, []);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        // lastReloadRef.current = new Date().getTime()/1000;
        if(data.transPlanTsrList) {
            // got order by hocha already
            transPlanLaunchListRepo({when:new Date().getTime()/1000, records:data.transPlanTsrList});
            // get max hocha (1 to maxHocha)
            let lastDockno = baseData.basicDockno;

            let launcherCount = data.transPlanTsrList.length;
            if(sessionInfo.user.isHomeplusUser()) launcherCount += 1; // 빈 상자 하나 추가.;
            const launchers = [];
            // set baseData and hocha first
            for(let i=1; i<=launcherCount; i++) {
                launchers.push({item:null, hocha:i});
            }
            // set item.
            data.transPlanTsrList.forEach(item => {
                const idx = item.hocha - 1;
                launchers[idx] = ({item:item, hocha:item.hocha});
            })
            setLaunchBoxList(launchers);
            setDocknoMemo(lastDockno);
            if(data.transPlanTsrList.length > 0) {
                const found = selected.item ?
                    data.transPlanTsrList.find(item=> item.planId === selected.item.planId) : null;
                if(found) {
                    setSelected({hocha:found.hocha, item:found});
                }
                else {
                    setSelected({hocha:data.transPlanTsrList[0].hocha, item:data.transPlanTsrList[0]});
                }
            }
            else setSelected(launchers[0] || {hocha:0, item:null});

            // set base data
            const store = storeList.records.find(item => item.storeId === listParam.storeId);
            if(store) {
                const newBaseData = {
                    dcCd: store.dcCd,
                    storeId: store.storeId,
                    arriveId: store.arriveId,
                    basicDockno: store.basicDockno,
                    planDate: listParam.planDate,
                    arriveInfo: store,
                };
                setBaseData(newBaseData);
                // setShowControls(data.transPlanTsrList.length > 0 ? false : true);
                setShowControls(data.transPlanTsrList.length > 0 ? false : true);
            }
            else {
                setBaseData({}); // reset base data
            }
        }
    };
    
    const onCompleteGetPlanItem = (data, option) => {
        if(data.transPlanTsrItem) {
            //setPlan(data.transPlanTsrItem);
            transPlanTsrItemRepo(data.transPlanTsrItem); // 상차상세내역, 물류집기 뷰를 위해서
            setOpenTsrDetail(true);
        }
        else addAlert({title:"배차정보 조회", message:['지정한 배차정보를 찾을 수 없습니다.']});
    };

    const onCompleteAdd = (data, clientOption) => {
        if(data.transPlanAdd.ok) {
            if(data.transPlanAdd.detail !== ApiMsg.OK) {
                addAlert({
                    title: "운송요청 추가",
                    message: [data.transPlanAdd.detail]
                });
            }
            else enqueueSnackbar('운송요청 정보가 생성되었습니다.', {variant: 'success', autoHideDuration: 1500});
            getTransPlanTsrListUsingParam();
        }
        else addAlert({title:'운송요청 등록 오류', message:[data.transPlanAdd.message]});
    };

    const onCompleteEdit = (data, clientOption) => {
        if(data.transPlanEdit.ok) {
            if(data.transPlanEdit.detail !== ApiMsg.OK) {
                addAlert({
                    title: "운송요청 수정",
                    message: [data.transPlanEdit.detail]
                });
            }
            else enqueueSnackbar('운송요청 정보가 수정되었습니다.', {variant: 'success', autoHideDuration: 1500});
            getTransPlanTsrListUsingParam();
        }
        else addAlert({title:'운송요청 수정 오류', message:[data.transPlanEdit.message]});
    };

    const onCompleteRemove = (data, clientOption) => {
        if(data.transPlanRemove.ok) {
            if(data.transPlanRemove.detail !== ApiMsg.OK) {
                addAlert({
                    title: "운송요청 삭제",
                    message: [data.transPlanRemove.detail]
                });
            }
            else enqueueSnackbar('운송요청 정보가 삭제되었습니다.', {variant: 'success', autoHideDuration: 1500});
            getTransPlanTsrListUsingParam();
        }
        else addAlert({title:'운송요청 삭제 오류', message:[data.transPlanRemove.message]});
    };
    
    const onCompleteGetStoreList = (data, clientOption) => {
        if(data.arriveInfoList) {
            if(data.arriveInfoList.length > 0) {
                // sort by storeId (text)
                data.arriveInfoList.sort((a,b) => {
                    if(a.storeId < b.storeId) return -1;
                    if(a.storeId > b.storeId) return 1;
                    return 0;
                });
                if(!transPlanLaunchListParam.storeId) {
                    const store = data.arriveInfoList[0];
                    const newParam = {...transPlanLaunchListParam, storeId:store.storeId};
                    transPlanLaunchListParamRepo(newParam);
                }
            }
            arriveInfoListToSelectStoreRepo({
                when:new Date().getTime()/1000,
                records:data.arriveInfoList
            });
        }
    };
    
    const onCompleteGetComList = (data, option) => {
        if(data.comInfoList) {
            comInfoListRepo({when:new Date().getTime()/1000, records:data.comInfoList});
        }
    };

    const onCompleteGetVehTypeList = (data, clientOption) => {
        if(data.vehTypeGroupOrderListByDc) {
            vehTypeGroupOrderListByDcRepo({when:new Date().getTime()/1000, records:data.vehTypeGroupOrderListByDc});
        }
    };

    const onCompleteGetVehInfoList = (data, clientOption) => {
        if(data.vehInfoListOfDc) {
            vehInfoListOfDcRepo({
                when:new Date().getTime()/1000,
                records:devideVehiclesByCompany(data.vehInfoListOfDc, vehSorter)
            });
        }
    };

    const onCompleteSetTruck = (data, clientOption) => {
        if(data.transPlanSetTruck.ok) {
            enqueueSnackbar('차량이 운송요청에 배차되었습니다.', {variant: 'success', autoHideDuration: 1500});
            getTransPlanTsrListUsingParam();
        }
        else addAlert({title:"차량배정 오류", message:[data.transPlanSetTruck.message]});
    };

    const onCompleteOffTruck = (data, clientOption) => {
        if(data.transPlanOffTruck.ok) {
            enqueueSnackbar('[배차취소] 차량배정이 초기화되었습니다.', {variant: 'success', autoHideDuration: 1500});
            getTransPlanTsrListUsingParam();
        }
        else addAlert({title:"차량배정 초기화 오류", message:[data.transPlanOffTruck.message]});
    };

    /* ################################################## */
    const onStoreSelected = (id, value) => {
        const newParam = {...listParam, storeId:value};
        setListParam(newParam);
        if(value && listParam.planDate) {
            getTransPlanTsrListNow(value, listParam.planDate);
        }
    };

    const onChangePlanDate = (id, value) => {
        const newParam = {...listParam, planDate:value};
        setListParam(newParam);
    };

    const onClickGetList = () => {
        if(listParam.storeId && IsValid.date(listParam.planDate)) {
            getTransPlanTsrListNow(listParam.storeId, listParam.planDate);
        }
    };

    const onClickTab = (hocha) => {
        const idx = launchBoxList.findIndex(item => item.hocha === hocha);
        if(idx > -1) {
            setSelected({hocha:hocha, item:launchBoxList[idx].item});
        }
    };

    const onRequestShowTsr = (item) => {
        getTransPlanTsrItem({variables:{planId:item.planId}});
    };

    const onRequestSetTruck = (param) => {
        setTransPlanTruck({variables:{transPlan:param}});
    };

    const onRequestSave = (item, isEdit) => {
        const mutateParam = {variables:{transPlan:item}};
        if(isEdit) editTransPlan(mutateParam);
        else addTransPlan(mutateParam);
    };

    const onRequestRemovePlan = (item) => {
        // confirm 후 요청된 것임.
        removeTransPlan({variables:{transPlan:{planId:item.planId}}});
    };

    const loadingAny
    = responseList.loading
    || responseStoreList.loading
    || responseVehTypeList.loading
    || responseComList.loading
    || responseVehInfoList.loading
    || responseAdd.loading
    || responseEdit.loading
    || responseRemove.loading
    || responseSetTruck.loading
    || responseOffTruck.loading
    || responsePlanItem.loading;

    const holdMutation
        = responseList.loading
        || responseAdd.loading
        || responseEdit.loading
        || responseRemove.loading
        || responseSetTruck.loading
        || responseOffTruck.loading
        || responsePlanItem.loading;

    return(
        <TopContainer>
            <TopHeader>
                <span>운송요청</span>
                {
                    showControls ? null :
                    <div
                        style={{
                            flexGrow:1, fontSize: '0.95rem',
                            overflow:'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
                            display:'flex', alignItems:'center', justifyContent:'flex-end',
                            color: AppStyle.PrimaryRGB,
                        }}
                        onClick={() => setShowControls(true)}
                    >
                        {listParam.planDate}, {baseData.arriveInfo && baseData.arriveInfo.storeName}
                        <KeyboardArrowDownIcon style={{marginLeft:'1rem', color: AppStyle.PrimaryRGB}}/>
                    </div>
                }
            </TopHeader>
            <TransitionGroup>
                {
                    showControls &&
                    <Collapse in={showControls}>
                        <ControlLine>
                            <VzmDateField
                                dict={{
                                    id: 'planDate',
                                    label: '출고일자'
                                }}
                                value={listParam.planDate || ''}
                                error={!IsValid.date(listParam.planDate)}
                                onChange={onChangePlanDate}
                            />
                            {
                                responseList.loading ?
                                <CircularProgress size={20} style={{marginLeft: 10}}/>
                                :
                                <Button
                                    variant={AppStyle.mui.contained}
                                    color={AppStyle.mui.primary}
                                    size={AppWord.SMALL}
                                    startIcon={<CloudDownloadIcon />}
                                    style={{marginLeft: 10}}
                                    onClick={onClickGetList}
                                    disabled={loadingAny || !listParam.storeId || !IsValid.date(listParam.planDate)}
                                >
                                    조회
                                </Button>
                            }
                            <div style={{flexGrow:1, textAlign:'right'}}>
                                <IconButton
                                    color={AppStyle.mui.secondary}
                                    size={AppWord.SMALL}
                                    onClick={() => setShowControls(false)}
                                    disabled={launchBoxList.length === 0}
                                >
                                    <KeyboardArrowUpIcon/>
                                </IconButton>
                            </div>
                        </ControlLine>
                        <ControlLine>
                            <AutoTextField
                                dict={{
                                    id:'storeId',
                                    label:'도착지',
                                    labelKey:'storeName',
                                    getOptionLabel: (opt) => opt.storeName + ' [' + opt.storeId + ']'
                                }}
                                value={listParam.storeId || ''}
                                list={storeList.records}
                                disabled={responseStoreList.loading}
                                style={{minWidth:240, marginLeft: 10}}
                                onChange={onStoreSelected}
                            />
                        </ControlLine>
                    </Collapse>
                }
            </TransitionGroup>
            <ControlLine style={{minHeight: 65}}>
                {
                    launchBoxList.length === 0 ?
                    <AppBar position="static" color={AppStyle.mui.primary}
                        style={{borderTop: '1px solid #ddd'}}
                    >
                        <Tabs value={0}
                            TabIndicatorProps={{
                            style: {
                                backgroundColor: 'white', // 하이라이트 색상을 흰색으로 변경
                            },
                        }}>
                            <Tab label="호차" disabled={true}
                                style={{color: 'white'}}
                            />
                        </Tabs>
                    </AppBar>
                    :
                    <AppBar position="static" color={AppStyle.mui.primary}
                        style={{borderTop: '1px solid #ddd'}}
                    >
                        <Tabs value={selected.hocha} onChange={(e, v)=>onClickTab(v)}
                            TabIndicatorProps={{
                            style: {
                                backgroundColor: 'yellow', // 하이라이트 색상을 yellow색으로 변경
                            },
                        }}
                        >
                            {
                                launchBoxList.map((item, idx) => {
                                    return(
                                        <Tab key={idx}
                                            value={item.hocha}
                                            label={`${item.hocha}호`}
                                            onClick={()=>{
                                                setSelected({hocha:item.hocha, item:item.item});
                                            }}
                                            style={{
                                                color: selected.hocha === item.hocha ? 'yellow' : 'white',
                                                fontWeight: selected.hocha === item.hocha ? 'bold' : 'normal',
                                                paddingLeft: 3, paddingRight: 3,
                                                minWidth: 45
                                            }}
                                        />
                                    );
                                })
                            }
                        </Tabs>
                    </AppBar>
                }
            </ControlLine>
            <TopContent>
                {
                    launchBoxList.length === 0 ?
                    <NoDataBox title={
                        listParam.storeId ?
                        "해당 점포에 배차가 없습니다." :
                        "점포를 선택하세요."
                    }/>
                    :
                    <TransPlanLaunchItem
                        hocha={selected.hocha}
                        baseData={baseData}
                        item={selected.item}
                        vehTypeList={vehTypeList}
                        comInfoList={comInfoList}
                        lastDockno={docknoMemo}
                        holdMutation={holdMutation}
                        onRequestSave={onRequestSave}
                        onRequestRemove={onRequestRemovePlan}
                        onRequestShowTsr={onRequestShowTsr}
                        onRequestSetTruck={onRequestSetTruck}
                    />
                }
            </TopContent>
            <TransPlanTsrGroup
                open={openTsrDetail}
                onClose={()=>setOpenTsrDetail(false)}
            />
        </TopContainer>
    );
}

/*

export default function TransPlanLaunchItem({
    hocha, // 호차
    baseData, // {dcCd, arriveId, storeId, planDate}
    item,
    vehTypeList,
    comInfoList,
    lastDockno,
    onRequestSave, // {param, isEdit}
    onRequestRemove,
    onRequestSetTruck,
    onRequestOffTruck,
    onRequestReload,
    onRequestPopupBindManager,
    holdMutation
})
*/
